// extracted by mini-css-extract-plugin
export default {"inst":"Institucional_inst__3SNTU"};